import { UnitPricing } from "@covertree/agent-portal-graphql";
import { reduceFees } from "./reduceFees";

export function calculateTotalDue(pricing: UnitPricing) {
  return (
    (pricing?.grossPremium ?? 0) +
    reduceFees(pricing) +
    (pricing?.grossTaxes ?? 0)
  );
}
